"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Correction = exports.CORRECTION_TYPES = exports.CorrectionTypes = void 0;
class CorrectionTypes {
    constructor() {
        this.BALANCE_CORRECTION = 'BALANCE_CORRECTION';
        this.PROJECTION_UPDATE = 'PROJECTION_UPDATE';
        this.UNSETTLED_ROLLOVER = 'UNSETTLED_ROLLOVER';
        this.PASS_THROUGH_ACCEPTANCE = 'PASS_THROUGH_ACCEPTANCE';
        this.MANUAL_CORRECTION = 'MANUAL_CORRECTION';
        this.TOLERANCE_CORRECTION = 'TOLERANCE_CORRECTION';
        this.MANUAL_MATCHING_ACCEPT = 'MANUAL_MATCHING_ACCEPT';
        this.MANUAL_MATCHING_ACCEPT_REVERSAL = 'MANUAL_MATCHING_ACCEPT_REVERSAL';
    }
}
exports.CorrectionTypes = CorrectionTypes;
exports.CORRECTION_TYPES = new CorrectionTypes();
// ------ Start of Schemer Auto Generated Code Block (Correction Typescript Model) ------ //
class Correction {
}
exports.Correction = Correction;
// ------ End   of Schemer Auto Generated Code Block (Correction Typescript Model) ------ //
//# sourceMappingURL=correction.js.map